export const geofenceType = {
  RIDE_ALLOW: 'ride_allow',
  RIDE_RESTRICT: 'ride_restrict',
  FINISH_ALLOW: 'finish_allow',
  FINISH_RESTRICT: 'finish_restrict',
  TECH_WORK_AREA: 'tech_work_area',
  SPEED_LIMIT: 'speed_limit',
  DEMAND: 'demand',
};
export type GeofenceType = typeof geofenceType[keyof typeof geofenceType];
